<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-PROVIDER' : 'EDIT-PROVIDER') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'PROVIDER' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'FIRST-NAME' | translate}}
                                    </span>
                                    <input id="firstName" kendoTextBox formControlName="firstName" maxlength="150" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="firstName.invalid && firstName.touched">
                                        {{'REQUIRED-FIRST-NAME' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'LAST-NAME' | translate}}
                                    </span>
                                    <input id="lastName" kendoTextBox formControlName="lastName" maxlength="150" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="lastName.invalid && lastName.touched">
                                        {{'REQUIRED-LAST-NAME' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'MIDDLE-NAME' | translate}}
                                    </span>
                                    <input id="middleName" kendoTextBox formControlName="middleName" maxlength="150" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'TITLE' | translate}}
                                    </span>
                                    <input id="title" kendoTextBox formControlName="title" maxlength="255" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SUFFIX' | translate}}
                                    </span>
                                    <input id="suffix" kendoTextBox formControlName="suffix" maxlength="50" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'PROFESSIONAL-SUFFIX' | translate}}
                                    </span>
                                    <input id="professionalSuffix" kendoTextBox formControlName="professionalSuffix"
                                        maxlength="50" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'GENDER' | translate}}
                                    </span>
                                    <kendo-combobox class="w-100" id="genderId" formControlName="genderId"
                                        [data]="genders" [textField]="'displayName'" [valueField]="'id'"
                                        [valuePrimitive]="true">
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-7">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'PROVIDER-NPI' | translate}} *
                                    </span>
                                    <input id="npi" kendoTextBox formControlName="npi" maxlength="50" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="npi.hasError('required') && npi.touched">
                                        {{'REQUIRED-NPI' | translate}}
                                    </div>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="npi.hasError('npiExists')">
                                        {{'PROVIDER-NPI-ALREADY-EXISTS' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-1">
                                <i class="fa fa-tag fa-1_5x pointer" title="{{'SET-NPI' | translate}}"
                                    style="position: relative;top: 44px;color: #c4ced8;" (click)="onAssignNPI()">
                                </i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'SPECIALTY' | translate}}
                                    </span>
                                    <kendo-combobox [data]="specialtiesFiltered" [textField]="'displayName'"
                                        [valueField]="'id'" [filterable]="true"
                                        (filterChange)="filterSpecialties($event)" (close)="searchTerm=''"
                                        [formControl]="specialtyId" [valuePrimitive]="true"
                                        [virtual]="virtualSpecialty">
                                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'QUALITY-SCORE' | translate}}
                                    </span>
                                    <kendo-numerictextbox [format]="'n0'" formControlName="qualityScore" class="w-50"
                                        [min]="0" [max]="100">
                                    </kendo-numerictextbox>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'PROVIDER-DESCRIPTION' | translate}}
                                    </span>
                                    <textarea id="description" kendoTextArea class="w-100" formControlName="description"
                                        maxlength="255"></textarea>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="description.hasError('required') && description.touched">
                                        {{'REQUIRED-PROVIDER-DESCRIPTION' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'ADDRESS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-8">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STREET' | translate}}
                                    </span>
                                    <input id="streetLine" kendoTextBox formControlName="streetLine" class="w-100" /> <i
                                        *ngIf="addressAPIEnabled && streetLine.value"
                                        class="far fa-search-location pointer ml-3 fa-1_5x"
                                        style="color:#3e807c;position:absolute;top:43px;"
                                        title="{{'VALIDATE-ADDRESS-ICON' | translate}}" (click)="validateAddress()"></i>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ADDRESS-LINE-2' | translate}}
                                    </span>
                                    <input id="streetLineAdditional" kendoTextBox formControlName="streetLineAdditional"
                                        class="w-100" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'CITY' | translate}}
                                    </span>
                                    <input id="city" kendoTextBox formControlName="city" class="w-100" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COUNTY' | translate}}
                                    </span>
                                    <input id="county" kendoTextBox formControlName="county" class="w-100"
                                        maxlength="150" />
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'STATE' | translate}}
                                    </span>
                                    <kendo-combobox id="state" class="w-100" formControlName="state" [data]="states"
                                        [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="true">
                                    </kendo-combobox>
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'POSTAL-CODE' | translate}}
                                    </span>
                                    <input id="postalCode" kendoTextBox formControlName="postalCode" class="w-100" />
                                </label>
                            </div>
                            <div class="col-4">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'COUNTRY' | translate}}
                                    </span>
                                    <kendo-combobox id="country" class="w-100" formControlName="country"
                                        [data]="countries" [textField]="'displayName'" [valueField]="'code'"
                                        [valuePrimitive]="true">
                                    </kendo-combobox>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'CONTACT' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-phone fa-fw"></i> {{'PHONE' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="telephoneNumber"
                                        formControlName="telephoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                            <div class="col-3 pl-0">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">{{'PHONE-EXTENSION' | translate}}
                                    </span>
                                    <input id="telephoneNumberExtension" kendoTextBox
                                        formControlName="telephoneNumberExtension" class="w-100" maxlength="20" />
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-mobile-android-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="cellPhoneNumber"
                                        formControlName="cellPhoneNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                            <div class="col-3">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-fax fa-fw"></i> {{'FAX' | translate}}
                                    </span>
                                    <kendo-maskedtextbox [mask]="phoneNumberMask" id="faxNumber"
                                        formControlName="faxNumber" class="w-100">
                                    </kendo-maskedtextbox>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-at fa-fw"></i> {{'DIRECT-ADDRESS' | translate}}&nbsp;
                                    </span>
                                    <input id="directAddress" kendoTextBox formControlName="directAddress" email
                                        class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="directAddress.invalid && directAddress.touched">
                                        {{'WRONG-DIRECT-ADDRESS-FORMAT' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}}&nbsp;
                                    </span>
                                    <input id="email" kendoTextBox formControlName="email" email class="w-100" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="email.invalid && email.touched">
                                        {{'WRONG-EMAIL-FORMAT' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label for="languages" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'LANGUAGES' | translate }}
                                    </span>
                                    <kendo-multiselect [data]="languagesFiltered" formControlName="languages"
                                        class="max-height" [textField]="'displayName'" [filterable]="true"
                                        [valueField]="'id'" (filterChange)="filterLanguages($event)"
                                        (close)="searchTerm=''" [autoClose]="true" [virtual]="virtualLanguage">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                                class="ellipsis-text">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="{{ 'ORGANIZATION' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row">
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'ORGANIZATION' | translate}}
                                    </span>
                                    <input id="organization" kendoTextBox formControlName="organization"
                                        maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="organization.invalid && organization.touched">
                                        {{'REQUIRED-ORGANIZATION' | translate}}
                                    </div>
                                </label>
                            </div>
                            <div class="col-6">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        <i (click)="openUrl()" [ngClass]="{'has-valid-url': isValidUrl()}"
                                            class="fas fa-link fa-fw"></i> {{'URL' |
                                        translate}}&nbsp;
                                    </span>
                                    <input id="url" kendoTextBox formControlName="url" class="w-100" maxlength="255" />
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="!isValidUrl() && url.hasError('pattern') && url.touched">
                                        {{'INVALID-WWW' | translate}}
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label for="facilities" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'FACILITIES' | translate }}
                                    </span>
                                    <kendo-multiselect [data]="facilitiesFiltered" formControlName="facilities"
                                        class="max-height" [textField]="'name'" [filterable]="true" [valueField]="'id'"
                                        (filterChange)="filterFacilities($event)" (close)="searchTerm=''"
                                        [autoClose]="true" [virtual]="virtualFacility">
                                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                            </span>
                                        </ng-template>
                                    </kendo-multiselect>
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty || saving"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-address-validator #addressValidator (changeAddress)="changeAddress($event)" (save)="saveProvider()"
    (cancelling)="saving = false;">
</app-address-validator>